import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {HomeLayoutComponent} from './layouts/home-layout.component';
import {SignUpComponent} from './authentication/sign-up/sign-up.component';
import {AuthGuard} from './auth.guard';
import {LoginComponent} from './authentication/login/login.component';
import {ForgetPasswordComponent} from './authentication/forget-password/forget-password.component';
import {LoginLayoutComponent} from './layouts/login-layout.component';
import {ResetPasswordComponent} from './authentication/reset-password/reset-password.component';
import {KitboardComponent} from './kitboard/kitboard.component';
import {KitmodelboardComponent} from './kitmodelboard/kitmodelboard.component';
import {DeviceViewComponent} from './device-view/device-view.component';
import {DeviceDataComponent} from './device-data/device-data.component';
import { KitHistoryComponent } from './kit-history/kit-history.component';
import {WifiConfigComponent} from './wifi-config/wifi-config.component';
import {MyComponentWrapperComponent} from '../components/my-react-component/MyReactComponentWrapper';
import { TestingAutomationComponentWrapper } from 'src/components/testing-automation/TestingAutomationComponentWrapper';
import { ProductTypComponentWrapper } from 'src/components/product-types/ProductTypesComponentWrapper';


const routes: Routes = [
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {path: '', component: MyComponentWrapperComponent},
      {path: 'devices', component: DashboardComponent},
      {path: 'devices/:coperateId/:filter/:favourite', component: DashboardComponent},
      {path: 'kits', component: KitboardComponent},
      {path: 'react', component: MyComponentWrapperComponent},
      {path: 'kit-models', component: KitmodelboardComponent},
      {path: 'wifi-config', component: WifiConfigComponent},
      {path: 'device-view/:deviceId', component: DeviceViewComponent},
      {path: 'device/:deviceId', component: DeviceDataComponent},
      {path: 'kit/:kitId', component: KitHistoryComponent},
      {path: 'testing',component:TestingAutomationComponentWrapper},
      {path: 'product-types',component:ProductTypComponentWrapper}
    ]
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'forgot-password',
        component: ForgetPasswordComponent
      },
      {
        path: 'sign-up',
        component: SignUpComponent
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent
      }
    ]
  },
  {path: '**', redirectTo: ''}
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
